export interface Payment {
  pSeq: number;
  convenienceFee?: number;
  amount: number;
  tax?: number;
  meetingId?: number | null;
  isAutopayCancellation?: boolean | null;
  isProduction?: boolean | null;
  location: string;
  forceCharge?: boolean | null;
}
